import * as userConstants from "@/core/models/usersAndPermissions";
import { routes } from "@/routing/routes";
import { DASHBOARD_WIZARD } from "@/core/constants/layout";

type routeWithItemIdAsParam = {
  itemId: string | null;
};

const router = [
  {
    path: routes.expedition.path,
    name: routes.expedition.name,
    props: (route: any): routeWithItemIdAsParam => ({
      itemId: route.query?.itemId ?? null,
    }),
    component: () =>
      import(/* webpackChunkName: "db-exped" */ "@/apps/dashboard/transport/view/pages/Expeditions/Expeditions.vue"),
    meta: {
      permission: userConstants.ROLE_BUYBACKITEM_SEND_PAGE,
    },
  },
  {
    path: routes.startExpedition.path,
    name: routes.startExpedition.name,
    component: () =>
      import(
        /* webpackChunkName: "db-exped-start" */ "@/apps/dashboard/transport/view/pages/StartExpedition/StartExpedition.vue"
      ),
    meta: {
      permission: userConstants.ROLE_BUYBACKITEM_SEND_PAGE,
    },
  },
  {
    path: routes.packingWithLabel.path,
    name: routes.packingWithLabel.name,
    props: (route: any): routeWithItemIdAsParam => ({
      itemId: route.query?.itemId ?? null,
    }),
    component: () =>
      import(
        /* webpackChunkName: "db-packing-with-label" */ "@/apps/dashboard/transport/view/pages/PackingWithLabel/PackingWithLabel.vue"
      ),
    meta: {
      permission: userConstants.ROLE_BUYBACKITEM_SEND_PAGE,
    },
  },
  {
    path: routes.confirmationExpedition.path,
    name: routes.confirmationExpedition.name,
    component: () =>
      import(
        /* webpackChunkName: "db-exped-conf" */ "@/apps/dashboard/transport/view/pages/ExpeditionConfirmation/ExpeditionConfirmation.vue"
      ),
    meta: {
      layoutType: DASHBOARD_WIZARD,
    },
  },
  {
    path: routes.transportsList.path,
    name: routes.transportsList.name,
    component: () =>
      import(
        /* webpackChunkName: "db-transports-list" */ "@/apps/dashboard/transport/view/pages/TransportsList/TransportsList.vue"
      ),
    meta: {
      permission: userConstants.ROLE_ADMIN_MENU,
    },
  },
];

export default router;
